import React from 'react';
import classnames from 'classnames';
import Button from '#components/Elements/Button/Button';

const ModalCardHead = ({
  onClose,
  children,
  className,
  showClose,
  ...props
}) => {
  if (!React.Children.count(children)) {
    return null;
  }
  return (
    <header {...props} className={classnames('modal-card-head', className)}>
      {children}
      {showClose && <Button remove onClick={onClose} />}
    </header>
  );
};

ModalCardHead.defaultProps = {
  showClose: true,
};

export default ModalCardHead;
